export default "__VITE_PUBLIC_ASSET__a8bc3194__"